import { createSlice } from "@reduxjs/toolkit";
import { getCustomerOrder } from "./customOrder.action";
import { ICustomOrderState } from "./customOrder.interface";

const initialState: ICustomOrderState = {
  wholesaleOrder: null,
  wholesaleOrderLoading: false,
  wholesaleOrderError: null,
};

const customOrderSlice = createSlice({
  name: "customOrder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCustomerOrder.pending, (state) => {
      state.wholesaleOrderLoading = true;
      state.wholesaleOrderError = null;
    });
    builder.addCase(getCustomerOrder.fulfilled, (state, action) => {
      state.wholesaleOrder = action.payload;
      state.wholesaleOrderLoading = false;
    });
    builder.addCase(getCustomerOrder.rejected, (state, action) => {
      state.wholesaleOrderError = action.payload;
      state.wholesaleOrderLoading = false;
      state.wholesaleOrder = null;
    });
  },
});

export default customOrderSlice.reducer;
